export function formatDate(date: Date) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [month, day, year] = [
    monthNames[date.getMonth()],
    date.getDate(),
    date.getFullYear(),
  ];
  return `${month} ${day + getSuffix(day)}, ${year}`;
}

function getSuffix(n: number) {
  return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
}

export const getUserGroupDisplayMap = (
  isOverhaul: boolean,
): Record<string, string> => ({
  CREATOR_PLAT: isOverhaul ? "Unlimited" : "Creator Platinum",
  PRO_PLUS: "Pro Plus",
  PRO: isOverhaul ? "Standard" : "Pro",
});
